<template>
    <v-container fluid id="logout-chart" class="pl-20 pr-15">
        <v-row class="mx-0">
            <v-sheet class="logout-chart">
                <div class="d-flex justify-space-between">
                    <div class="chart-card">
                        <p class="chart-card-text chard-chart-top-text">Enterprise Digital Risk</p>
                        <p class="chart-card-text chart-card-price">
                            $527K
                            <span class="percent-arrow">
                                <span class="material-icons">arrow_upward</span>
                                    10%
                            </span>
                        </p>
                        <p class="chart-card-text chart-card-progress">
                            <v-progress-linear value="38" height="6" class="line" attach></v-progress-linear>
                        </p>
                        <p class="chart-card-text chart-card-btn-text">Industry Rank</p>
                    </div>
                    <div class="chart-card">
                        <p class="chart-card-text chard-chart-top-text">Personal Data Elements</p>
                        <p class="chart-card-text chart-card-price">
                            24,091
                            <span class="percent-arrow">
                                <span class="material-icons">arrow_downward</span>
                                    4%
                            </span>
                        </p>
                        <p class="chart-card-text chart-card-progress">
                            <v-progress-linear value="38" height="6" class="line" attach></v-progress-linear>
                        </p>
                        <p class="chart-card-text chart-card-btn-text">Industry Rank</p>
                    </div>
                    <div class="chart-card">
                        <p class="chart-card-text chard-chart-top-text">@Risk for Regulation</p>
                        <p class="chart-card-text chart-card-price">
                            183
                            <span class="percent-arrow">
                                <span class="material-icons">arrow_upward</span>
                                    22%
                            </span>
                        </p>
                        <p class="chart-card-text chart-card-progress">
                            <v-progress-linear value="38" height="6" class="line" attach></v-progress-linear>
                        </p>
                        <p class="chart-card-text chart-card-btn-text">Industry Rank</p>
                    </div>
                    <div class="chart-card">
                        <p class="chart-card-text chard-chart-top-text">Percent to Complience Target</p>
                        <p class="chart-card-text chart-card-price">
                            27%
                            <span class="percent-arrow arrow-none">
                                    Due Date 20,29
                            </span>
                        </p>
                        <p class="chart-card-text chart-card-progress">
                            <v-progress-linear value="38" height="6" class="line" attach></v-progress-linear>
                        </p>
                        <p class="chart-card-text chart-card-btn-text">Industry Rank</p>
                    </div>
                </div>
            </v-sheet>
        </v-row>
    </v-container>
</template>

<script>
export default {
  name: 'LogoutChart'
}
</script>

<style scoped>

</style>
